export default function audioConfiguration() {

  return {
    restrict: 'E',
    templateUrl: 'assets/javascripts/xchelper/directives/audioConfiguration.html',
    controller: ($scope, mediaDevices, webRtcAudio, AudioDevicesMgrService, $rootScope, XucPhoneState, WebHIDHeadsetService, ExternalEvent) => {

      $scope.ringtoneDevices = [];
      $scope.audioDevices = [];
      $scope.microphoneDevices = [];
      $scope.headsetName = WebHIDHeadsetService.getCurrentDeviceName();
      $scope.showMicrophoneLevel = false;
      $scope.microphoneLevel = 0;

      $scope.isPlayingAudioOutput = AudioDevicesMgrService.isPlaying('output');
      $scope.isPlayingRingingDevice = AudioDevicesMgrService.isPlaying('ringing');

      $rootScope.$on('AudioTestStateChanged', (_, data) => {
        if (data.deviceType === 'output') {
          $scope.isPlayingAudioOutput = data.isPlaying;
        } else if (data.deviceType === 'ringing') {
          $scope.isPlayingRingingDevice = data.isPlaying;
        }
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on('MicrophoneTestStateChanged', (_, data) => {
        $scope.showMicrophoneLevel = data.isActive;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on('MicrophoneLevelUpdate', (_, data) => {
        $scope.microphoneLevel = data.level;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(ExternalEvent.WEBHID_DEVICE_SELECTED, (_, device) => {
        console.debug(`Received ${device} in ContentSettingsController`);
        $scope.headsetName = device;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.AUDIO_DEVICE_PICKED_EVT, (_e, device) => {
        $scope.selectedAudioDevice = device.deviceId;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.MIC_DEVICE_PICKED_EVT, (_e, device) => {
        $scope.selectedMicrophoneDevice = device.deviceId;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.RINGING_DEVICE_PICKED_EVT, (_e, device) => {
        $scope.selectedRingingDevice = device.deviceId;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.AUDIO_DEVICE_UPDATE_EVT, (_e, devices) => {
        $scope.audioDevices = devices;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.MIC_DEVICE_UPDATE_EVT, (_e, devices) => {
        $scope.microphoneDevices = devices;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.RINGING_DEVICE_UPDATE_EVT, (_e, devices) => {
        $scope.ringingDevices = devices;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      AudioDevicesMgrService.initAudioDevices();

      $scope.changeAudioOutputDevice = (deviceId) => {
        AudioDevicesMgrService.changeAudioOutputDevice(deviceId);
      };

      $scope.changeAudioInputDevice = (deviceId) => {
        AudioDevicesMgrService.changeAudioInputDevice(deviceId);
      };

      $scope.changeRingingDevice = (deviceId) => {
        AudioDevicesMgrService.changeRingingDevice(deviceId);
      };

      $scope.getAudioInputStatus = () => {
        return XucPhoneState.getDeviceConference().calls.length > 0 ? 'disabled' : '';
      };

      $scope.testAudioOutput = () => {
        AudioDevicesMgrService.testAudioDevice($scope.selectedAudioDevice, 'output');
      };

      $scope.testRingingDevice = () => {
        if ($scope.selectedRingingDevice === 'null') {
          return;
        }
        AudioDevicesMgrService.testAudioDevice($scope.selectedRingingDevice, 'ringing');
      };

      $scope.toggleMicrophoneTest = () => {
        AudioDevicesMgrService.toggleMicrophoneTest($scope.selectedMicrophoneDevice);
      };

      $scope.$on('$destroy', () => {
        AudioDevicesMgrService.stopAllAudioTests();
      });
    }
  };
}
